import { ButtonHTMLAttributes, FC } from 'react'
import styled from 'styled-components'
import { COLORS } from '@assets/styles/colors'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	width?: number
	height?: number
}

export const YellowFilledButton: FC<ButtonProps> = styled.button`
	width: ${props => props.width || 100}px;
	height: ${props => props.height || 40}px;
	color: black;
	background: ${COLORS.DECORATIVE_YELLOW};
	border: none;
	border-radius: 22px;
	cursor: pointer;
	transition:
		transform 140ms cubic-bezier(0.23, 1, 0.32, 1),
		opacity 140ms ease;

	&:active {
		transform: scale(0.97);
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.45;
	}
`
